var exports = {
  "e4": "xa15a2ab7--a6a7b3--banks",
  "rE": "xa15a2ab7--a6a7b3--bank",
  "Kk": "xa15a2ab7--a6a7b3--icon",
};

module.exports = exports;
